export abstract class RtUIOptions {
  public debug?: boolean = false;
}
